package music.limasoul.client.shared.event.domain.usecase

import music.jammers.client.shared.event.domain.repository.EventRepository
import music.jammers.shared.event.domain.model.Event

class LoadEventsUseCase(
    private val repository: EventRepository,
) {

    suspend operator fun invoke(): List<Event> =
        repository.getAll()
}